import { useState } from "react"
import { Layout } from "../../../ui/layout"
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { RIDMonitoringListClose } from "./monitoringRidListClose"
import { RIDMonitoringListOpen } from "./monitoringRidListOpen"

export function MonitoraggioRID() {
    const [selectedTab, setSelectedTab] = useState<number>(0)

    return (
        <Layout menuItem={MenuItems.GESTIONE_CLIENTI} breadcrumbItems={['Gestione Clienti', 'Monitoraggio RID']}
            noPaddingLat
            headerLabel="Monitoraggio R.I.D."
            headerChildren={
                <div className="flex h-full w-full items-center justify-end" />
            }
        >
            <div className="min-w-0 max-w-full overflow-x-hidden">
                <CustomHorizontalTab
                    selectedIndex={selectedTab}
                    onTabClick={(index) => setSelectedTab(index)}
                >
                    <div>Aperte</div>
                    <div>Chiuse</div>
                </CustomHorizontalTab>
                <div className="flex h-full min-w-0 max-w-full overflow-x-hidden bg-brandPrimary-100">
                    <div className="fieldset flex-1 min-w-0 max-w-full overflow-x-hidden rounded-tr-2xl bg-brandPrimary-200">
                    {
                        selectedTab === 0 &&
                        <RIDMonitoringListOpen />
                    }
                    {
                        selectedTab === 1 &&
                        <RIDMonitoringListClose />
                    }
                    </div>
                </div>
            </div>
        </Layout>
    )
}